
import axios from 'axios';

export default {
    state: {
        villages: [],
        streets: [],
        buildings: [],
    },
    mutations: {
        SET_VILLAGES(state, data) {
            state.villages = data;
        },
        SET_STREETS(state, data) {
            state.streets = data;
        },
        SET_BUILDINGS(state, data) {
            state.buildings = data;
        }
    },
    actions: {
        loadVillages({ commit }) {
            axios.get('/api/dictionary/get-villages?districtId=388').then(resp => { // 388 Тернопільский район
                commit('SET_VILLAGES', Array.isArray(resp.data) ? resp.data : []);
            }).catch(e => console.log(e));
        },
        loadStreets({ commit }, { cityId, districtId }) {
            axios.get('/api/dictionary/get-streets', {
                params: {
                    districtId,
                    cityId
                }
            }).then(resp => {
                commit('SET_STREETS', Array.isArray(resp.data) ? resp.data : []);
            }).catch(e => console.log(e));
        },
        loadBuildings({ commit }, streetId) {
            axios.get('/api/dictionary/get-buildings', {
                params: {
                    streetId
                }
            }).then(resp => {
                commit('SET_BUILDINGS', Array.isArray(resp.data) ? resp.data : []);
            }).catch(e => console.log(e));
        },
    }
}